"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoTokenToJSON = exports.PromoTokenFromJSONTyped = exports.PromoTokenFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PromoTokenFromJSON(json) {
    return PromoTokenFromJSONTyped(json, false);
}
exports.PromoTokenFromJSON = PromoTokenFromJSON;
function PromoTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'type': (0, _1.PromoTokenTypeFromJSON)(json['type']),
        'targetUrl': !(0, runtime_1.exists)(json, 'targetUrl') ? undefined : json['targetUrl'],
        'isEnabled': json['isEnabled'],
        'isBranded': !(0, runtime_1.exists)(json, 'isBranded') ? undefined : json['isBranded'],
        'couponCodes': !(0, runtime_1.exists)(json, 'couponCodes') ? undefined : json['couponCodes'],
        'qrImageUrl': !(0, runtime_1.exists)(json, 'qrImageUrl') ? undefined : json['qrImageUrl'],
        'expiresAt': !(0, runtime_1.exists)(json, 'expiresAt') ? undefined : json['expiresAt'],
        'maxLimit': !(0, runtime_1.exists)(json, 'maxLimit') ? undefined : json['maxLimit'],
    };
}
exports.PromoTokenFromJSONTyped = PromoTokenFromJSONTyped;
function PromoTokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'name': value.name,
        'description': value.description,
        'type': (0, _1.PromoTokenTypeToJSON)(value.type),
        'targetUrl': value.targetUrl,
        'isEnabled': value.isEnabled,
        'isBranded': value.isBranded,
        'couponCodes': value.couponCodes,
        'qrImageUrl': value.qrImageUrl,
        'expiresAt': value.expiresAt,
        'maxLimit': value.maxLimit,
    };
}
exports.PromoTokenToJSON = PromoTokenToJSON;
